/**
 * Flash Sale 도메인 쿼리 키 팩토리
 */

export const flashSaleKeys = {
  all: ["flash-sales"] as const,
  lists: ["flash-sales", "list"] as const,
  detail: (slug: string) => ["flash-sales", "detail", slug] as const,
  bulkQuote: (zipCode: string) => ["flash-sales", "bulk-quote", zipCode] as const,
  returnedStocks: (id: number) => ["flash-sales", "returned-stocks", id] as const,
};
